import * as React from "react";
import { Selectors } from "@grandvisionhq/auth";
import { MediaQuery, Logo, SupportFooter, ScrollIntoView } from "@grandvisionhq/common";
import { Alert } from "@grandvisionhq/iris-ui";
import { SplitPane } from "@grandvisionhq/layout";
import { useIntl, useStore, useSelector } from "@grandvisionhq/state";
import { getSelectedShippingMethod } from "../../StepShipping/StepShipping/selectors.js";
/* empty css                    */
import { StepNames } from "../../models/models/shared.js";
import { CheckoutStepErrorType } from "../../models/checkout/models/checkout/checkout-step-error-type.js";
import { NavigationContainer } from "../../modules/Navigation/modules/Navigation/NavigationContainer.js";
const CheckoutLayout = ({
  hasNavigation,
  logo,
  status,
  currentStep,
  pageRouteRoot,
  leftContentSection,
  cartContentSection
}) => {
  const isOverviewStep = currentStep === StepNames.Overview;
  const isShippingStep = currentStep === StepNames.Shipping;
  const { getLabel } = useIntl();
  const headerRef = React.useRef(null);
  const store = useStore();
  const isLoggedIn = Selectors.isLoggedIn(store.getState());
  const currentBreakpoint = MediaQuery.useBreakpoint();
  const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
  const selectedShippingMethod = useSelector(getSelectedShippingMethod);
  React.useEffect(() => {
    headerRef.current && headerRef.current.scrollIntoView();
  }, []);
  const alerts = [
    {
      condition: status === CheckoutStepErrorType.Failed,
      titleKey: "checkout.errors.general.title",
      messageKey: "checkout.errors.general.message"
    },
    {
      condition: status === CheckoutStepErrorType.ProductPriceUpdated,
      titleKey: "checkout.errors.general.payment.productPriceUpdated.title",
      messageKey: "checkout.errors.general.payment.productPriceUpdated.message"
    },
    {
      condition: status === CheckoutStepErrorType.ShippingStepFailed,
      titleKey: "checkout.errors.general.shipping.title",
      messageKey: "checkout.errors.general.shipping.message"
    },
    {
      condition: !selectedShippingMethod?.isValid && selectedShippingMethod?.isTouched && isShippingStep,
      titleKey: "checkout.warning.invalid.delivery.title",
      messageKey: "checkout.warning.invalid.delivery.message"
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "checkout-section" }, /* @__PURE__ */ React.createElement("div", { className: "checkout-section__header", ref: headerRef }, logo && /* @__PURE__ */ React.createElement(
    Logo,
    {
      className: "checkout-section__logo",
      url: pageRouteRoot,
      image: logo,
      title: logo.altText
    }
  ), hasNavigation && /* @__PURE__ */ React.createElement(NavigationContainer, { currentStep, isLoggedIn })), /* @__PURE__ */ React.createElement(
    SplitPane,
    {
      main: /* @__PURE__ */ React.createElement("div", { className: "checkout-section--main" }, isMobile && !isOverviewStep && /* @__PURE__ */ React.createElement("div", { className: "checkout-section__cart" }, cartContentSection), /* @__PURE__ */ React.createElement("div", { className: "checkout-section__body" }, alerts.filter(({ condition }) => condition).map((alert, index) => /* @__PURE__ */ React.createElement(ScrollIntoView, { key: alert.messageKey }, /* @__PURE__ */ React.createElement(
        Alert,
        {
          key: index,
          className: "alert-m-default checkout-section__alert",
          variant: "warning",
          title: getLabel(alert.titleKey)
        },
        getLabel(alert.messageKey)
      ))), leftContentSection)),
      aside: /* @__PURE__ */ React.createElement("div", { className: "checkout-section--aside" }, !isMobile && /* @__PURE__ */ React.createElement("div", { className: "checkout-section__cart" }, cartContentSection ? cartContentSection : null), /* @__PURE__ */ React.createElement("div", { className: "checkout-section__support-footer" }, /* @__PURE__ */ React.createElement(
        SupportFooter,
        {
          message: getLabel("support.title"),
          phoneNumber: getLabel("support.phoneNumber", { hideLabelKey: true }) || void 0,
          email: getLabel("support.emailAddress", { hideLabelKey: true }) || void 0
        }
      )))
    }
  ));
};
export {
  CheckoutLayout
};
//# sourceMappingURL=CheckoutLayout.js.map
